import React,{useState} from 'react'

export default function LiquidConversions() {

    /**New change */
    const [ml, setMl] = useState(0) // - done
    const [l, setL] = useState(0)
    const [cc, setCc] = useState(0)
    const [cm, setCm] = useState(0)
    const [fo, setFo] = useState(0)
    const [p, setP] = useState(0)
    const [q, setQ] = useState(0)
    const [g, setG] = useState(0)

    /**Disabling the mouse wheel */
    const inputFields = document.querySelectorAll('.highlight');
    inputFields.forEach(function(inputField) {
            inputField.addEventListener('wheel', function(event) {
            event.preventDefault();
        });
    })

  return (


    <div>
        <div  style={{display:"flex", justifyContent:"center"}}>
            <h2 style={{color:"#F9D081"}}>Volume Conversions</h2>
        </div>
      <div className="grid-container" style={{backgroundColor:"#o44f44d", marginLeft:"25%", marginRight:"25%"}}>        
            <div  >
                <div><label id="myLabels" htmlFor="number">Millileter (ml)</label></div>
                
                <input  className='highlight'type="number" 
                value={ml}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMl(a);
                    setL(a*0.001 );
                    setCc(a*1);
                    setCm(a*0.000001);
                    setFo(a*0.033814);
                    setP(a*0.002113);
                    setQ(a*0.001057);
                    setG(a*0.000264);
            }}/></div> 


             <div  >
                <div><label id="myLabels" htmlFor="number">Liters (l)</label></div>
                
                <input  className='highlight'type="number" 
                value={l}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMl(a*1000);
                    setL(a);
                    setCc(a*1000);
                    setCm(a*0.001);
                    setFo(a*33.814);
                    setP(a*2.113);
                    setQ(a*1.057);
                    setG(a*0.264);
            }}/></div>     

<div  >
                <div><label id="myLabels" htmlFor="number">Cubic centimeters (cm<sup>3</sup>)</label></div>
                
                <input  className='highlight'type="number" 
                value={cc}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMl(a*1);
                    setL(a*0.001);
                    setCc(a);
                    setCm(a*0.000001);
                    setFo(a*0.033814);
                    setP(a*0.002113);
                    setQ(a*0.001057);
                    setG(a*0.000264);
            }}/></div> 


            <div>
                <div><label id="myLabels" htmlFor="number">Cubic meters (m<sup>3</sup>)</label></div>
                
                <input  className='highlight'type="number" 
                value={cm}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMl(a*1000000);
                    setL(a*1000);
                    setCc(a*1000000);
                    setCm(a);
                    setFo(a*33814);
                    setP(a*2113);
                    setQ(a*1057);
                    setG(a*264.172);
            }}/></div> 

<div>
                <div><label id="myLabels" htmlFor="number">Fluid ounces (fl oz)</label></div>
                
                <input  className='highlight'type="number" 
                value={fo}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMl(a*29.475);
                    setL(a*0.0295735);
                    setCc(a*29.5735);
                    setCm(a*0.0000295735);
                    setFo(a);
                    setP(a*0.0625);
                    setQ(a*0.03125);
                    setG(a*0.0078125);
            }}/></div> 



            <div>
                <div><label id="myLabels" htmlFor="number">Pint (pt)</label></div>
                
                <input  className='highlight'type="number" 
                value={p}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMl(a*473.176);
                    setL(a*0.473176);
                    setCc(a*473.176);
                    setCm(a*0.000473176);
                    setFo(a*16);
                    setP(a);
                    setQ(a*0.5);
                    setG(a*0.125);
            }}/></div> 

                <div>
                <div><label id="myLabels" htmlFor="number">Quart (qt)</label></div>
                
                <input  className='highlight'type="number" 
                value={q}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMl(a*946.353);
                    setL(a*0.946353);
                    setCc(a*946.353);
                    setCm(a*0.000946353);
                    setFo(a*32);
                    setP(a*2);
                    setQ(a);
                    setG(a*0.25);
            }}/></div> 


<div>
                <div><label id="myLabels" htmlFor="number">Gallons (gal)</label></div>
                
                <input  className='highlight'type="number" 
                value={g}
                onChange={(e) => {
                    const a = parseFloat(e.target.value)
                    setMl(a*3,785.41);
                    setL(a*3.78541);
                    setCc(a*3785410);
                    setCm(a*0.00378541);
                    setFo(a*128);
                    setP(a*8);
                    setQ(a*4);
                    setG(a);
            }}/></div> 
        </div> 

        <div  style={{display:"flex", justifyContent:"center"}}>
        <button className='clear-button' onClick={(e) => {
            setMl(0);
            setL(0);
            setCc(0);
            setCm(0);
            setFo(0);
            setP(0);
            setQ(0);
            setG(0);
    }}>
        Clear Button
    </button>
        </div>
    </div>


)
}


// import React,{useState} from 'react'

// export default function LiquidConversions() {
//     const [liquidMO, setLiquidMO] = useState()
//     const [liquidLP, setLiquidLP] = useState()
//     const [liquidLQ, setLiquidLQ] = useState()
//     const [liquidLG, setLiquidLG] = useState()


//     const milileterToOz = 0.033814;
//     const literToPints = 2.11338;
//     const literToQuarts = 1.05669;
//     const literToGallons = 0.264172;
//   return (
//     <div  className="grid-container" style={{backgroundColor:"#o44f44d", marginLeft:"25%", marginRight:"25%"}}>
//       <div style={{display:"flex", justifyContent:"center"}}>
//         <h2 style={{color:"#F9D081"}}>Capacity Conversions</h2>
//         </div>
//       <div className="row" id="rows">
//             <div className="col" id="cols" >
//                 <div><label id="myLabels" htmlFor="number">Milileters(ml)</label></div>
                
//                 <input type="number" onChange={(e) => {
//                 setLiquidMO(e.target.value*milileterToOz)
//             }}/></div>
//             <div className="col" id="cols">
//                 <div><label id="myLabels" htmlFor="number">Ounces(Oz)</label></div>
//             <input type="text" value={liquidMO} disabled/>
//             </div>
//         </div>

//         <div className="row" id="rows">
//             <div className="col" id="cols" >
//                 <div><label id="myLabels" htmlFor="number">Liters(l)</label></div>
                
//                 <input type="number" onChange={(e) => {
//                 setLiquidLP(e.target.value*literToPints)
//             }}/></div>
//             <div className="col" id="cols">
//                 <div><label id="myLabels" htmlFor="number">Pints(pt)</label></div>
//             <input type="text" value={liquidLP} disabled/>
//             </div>
//         </div>

//         <div className="row" id="rows">
//             <div className="col" id="cols" >
//                 <div><label id="myLabels" htmlFor="number">Liters(l)</label></div>
                
//                 <input type="number" onChange={(e) => {
//                 setLiquidLQ(e.target.value*literToQuarts)
//             }}/></div>
//             <div className="col" id="cols">
//                 <div><label id="myLabels" htmlFor="number">Quarts(qt)</label></div>
//             <input type="text" value={liquidLQ} disabled/>
//             </div>
//         </div>

//         <div className="row" id="rows">
//             <div className="col" id="cols" >
//                 <div><label id="myLabels" htmlFor="number">Liters(l)</label></div>
                
//                 <input type="number" onChange={(e) => {
//                 setLiquidLG(e.target.value*literToGallons)
//             }}/></div>
//             <div className="col" id="cols">
//                 <div><label id="myLabels" htmlFor="number">Gallons(gal)</label></div>
//             <input type="text" value={liquidLG} disabled/>
//             </div>
//         </div>

//     </div>
//   )
// }
